module.exports = __webpack_public_path__ + "img/pain-spot-3.15cba3b6.svg";